/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    bool,
    func,
    object, shape, string,
} from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import { useDispatch } from 'react-redux';
import ProductNameRender from '../common/ProductNameRender';
import { setProductUnAvailable } from '../../../../../../state/ducks/App/App-Actions';

const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: '10px',
    },
    label: {
        fontWeight: 700,
        fontStyle: 'normal',
        fontSize: '20px',
        color: theme.palette.configuratorLabels || '#3A0703',
    },
    itemBox: {
        position: 'relative',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: theme.palette.configuratorBox || 'rgba(141, 141, 141, 1)',
        padding: '12px 0',
        textAlign: 'center',
        cursor: 'pointer',
        '& label': {
            padding: '0 2px',
        },
    },
    itemBoxSelected: {
        position: 'relative',
        borderWidth: '3px',
        borderStyle: 'solid',
        borderColor: theme.palette.configuratorBoxSelected || 'rgba(124, 37, 41, 1)',
        padding: '4px 0 !important',
        textAlign: 'center',
        cursor: 'pointer',
    },
    containerBox: {
        marginBottom: '20px',
    },
    disabled: {
        background: theme.palette.configuratorBoxDisabled || '#F2F2F2',
        textDecoration: 'line-through',
        backgroundSize: '100% 100%;',
    },
    hiddenRadio: {
        margin: 0,
        opacity: 0,
        borderRadius: 0,
        width: '100%',
        minHeight: '28px',
    },
    checkboxLabel: {
        left: '0',
        right: '0',
        bottom: '0',
        display: 'flex',
        top: '0',
        position: 'absolute',
        justifyContent: 'center',
        flexDirection: 'row',
        alignContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
    },
    radioButtonsBox: {
        padding: '6px 0',
    },
    capitalize: {
        textTransform: 'capitalize',
    },
}));

const FoodConfiguratorOptionUI = ({
    product,
    selectedSku,
    renderSingleUI,
    attributesValue,
    attributesList,
    setValue,
    setPreSelect,
}) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const renderOption = (items, label, radioName, handleClick, selectedItem = {}, capWords = false) => (
        <Grid
            className={classes.containerBox}
            item
            xs={12}
            onClick={() => {
                if (typeof window !== 'undefined') {
                    window.foodConfiguratorMounted = true;
                }
            }}
        >
            <Grid container spacing={2}>
                <Grid className={classes.label} item xs={12}>{label}</Grid>
                {(items || []).map((item, key) => item?.label
                    && (
                        <Grid item xs={3}>
                            <div
                                data-sku={item.sku}
                                className={`${capWords ? classes.capitalize : ''} ${item?.disabled ? classes.disabled : ''} ${item?.item_id === selectedItem?.item_id ? classes.itemBoxSelected : classes.itemBox} ${classes.radioButtonsBox}`}
                            >
                                <input
                                    tabIndex="0"
                                    className={classes.hiddenRadio}
                                    id={`${item.item_id}_${key}`}
                                    data-testid={`${radioName}_${key}`}
                                    type="radio"
                                    name={radioName}
                                    checked={(item?.item_id === selectedItem?.item_id)}
                                    onChange={() => {
                                        setPreSelect(null);
                                        if (!item?.disabled) {
                                            handleClick(item, radioName);
                                            dispatch(setProductUnAvailable(false));
                                        } else {
                                            handleClick(item, radioName);
                                            dispatch(setProductUnAvailable(true));
                                        }
                                    }}
                                />
                                <label className={`${classes.checkboxLabel} ${item?.disabled ? classes.disabled : ''}`} htmlFor={`${item.item_id}_${key}`}>
                                    <span>{item?.label}</span>
                                </label>
                            </div>
                        </Grid>
                    ),
                )}
            </Grid>
        </Grid>
    );

    return (
        <>
            {!renderSingleUI
                && (
                    <ProductNameRender
                        product={product}
                        selectedSku={selectedSku}
                        configuratorProduct
                        flagIsAvailableToShipNow
                    />
                )}
            <Grid container alignItems="flex-start" className={classes.root}>
                {(Object.keys(attributesList)).map((item) => {
                    if (attributesList[item]?.totalItems > 0 && attributesList[item]?.list?.length > 0) {
                        return (
                            <>
                                {renderOption(attributesList[item]?.list, attributesList[item]?.label, item, setValue[item], attributesValue[item], true)}
                            </>
                        );
                    }
                    return <></>;
                })}
            </Grid>
        </>
    );
};

FoodConfiguratorOptionUI.propTypes = {
    selectedSku: shape({
        id: string,
    }),
    product: shape({
        name: string,
    }),
    renderSingleUI: bool,
    attributesList: object,
    attributesValue: object,
    setValue: func,
    setPreSelect: func,
};
FoodConfiguratorOptionUI.defaultProps = {
    selectedSku: {},
    product: {},
    renderSingleUI: false,
    attributesValue: {},
    attributesList: {},
    setValue: () => { },
    setPreSelect: () => {},
};

export default FoodConfiguratorOptionUI;
